import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Plus, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { PageHeader } from "@/components/common";
import { ReminderDialog } from "@/components/forms";
import { RemindersList } from "@/components/tables";
import { useList } from "@/lib/hooks";
import { todayStr } from "@/lib/constants";

const FILTERS = { overdue: "En retard", today: "Aujourd'hui" };

export default function Reminders() {
  const [tab, setTab] = useState("todo");
  const [open, setOpen] = useState(false);
  const [params, setParams] = useSearchParams();
  const f = tab === "todo" ? params.get("f") : null;
  const { items, reload } = useList("/reminders", { done: tab === "done" });
  const today = todayStr();
  const shown = !f ? items : items.filter((r) => (f === "overdue" ? r.due_date < today : r.due_date === today));

  return (
    <>
      <PageHeader title="Suivis & maintenance" subtitle="Rappels de suivi client et contrats de maintenance (récurrence automatique)">
        <Button onClick={() => setOpen(true)} className="dt-glow" data-testid="new-reminder-button"><Plus className="mr-1 h-4 w-4" />Nouveau rappel</Button>
      </PageHeader>
      <Tabs value={tab} onValueChange={setTab}>
        <TabsList>
          <TabsTrigger value="todo" data-testid="reminders-tab-todo">À faire</TabsTrigger>
          <TabsTrigger value="done" data-testid="reminders-tab-done">Faits</TabsTrigger>
        </TabsList>
      </Tabs>
      {FILTERS[f] && (
        <button onClick={() => setParams({})} data-testid="reminders-filter-chip" className="inline-flex items-center gap-1 rounded-full border border-cyan-400/40 bg-cyan-400/10 px-3 py-1 text-sm text-cyan-200">
          Filtre : {FILTERS[f]} <X className="h-3.5 w-3.5" />
        </button>
      )}
      <RemindersList items={shown} reload={reload} />
      <ReminderDialog open={open} onOpenChange={setOpen} initial={{}} onSaved={reload} />
    </>
  );
}
